import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as userTermSelectors from "./userTermSelectors";
import * as userTermActions from "./userTermActions";
import { PageHeader } from "../common/PageHeader";
import { routes } from "../../appRoutingHelpers";
import UserTermVersionListRow from "./UserTermVersionListRow";
import Spinner from "../common/Spinner";

interface Props {}

const UserTermVersionList: React.FC<Props> = (props) => {
  // const t = (props as any).t;
  const dispatch = useDispatch();
  const { userTermId } = useParams<{ userTermId: string }>();

  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const userTermVersions = useSelector((state: RootState) =>
    userTermSelectors.listUserTermVersions(
      state,
      organizationKeyName,
      userTermId!
    )
  );

  const isLoading = false;

  React.useEffect(() => {
    dispatch(
      userTermActions.getUserTermVersionListAction(
        organizationKeyName,
        userTermId!
      )
    );
  }, [dispatch, organizationKeyName, userTermId]);

  return (
    <div className="container">
      <PageHeader
        title="User term list"
        breadcrumbs={[
          { title: "User Term list" },
          { title: "Overview", isActive: true },
        ]}
      />

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">User Term Version List</h3>
              <div className="card-options">
                <Link
                  className="btn btn-primary btn-sm"
                  to={routes.userTermVersionAdd(
                    organizationKeyName,
                    userTermId
                  )}
                >
                  New user term version
                </Link>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-outline table-vcenter card-table">
                <thead>
                  <tr>
                    <th>link</th>
                    <th>locale</th>
                    <th>version</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {userTermVersions?.map((userTermVersion) => (
                    <UserTermVersionListRow
                      organization={organizationKeyName}
                      key={userTermVersion.id}
                      userTermId={userTermId}
                      userTermVersion={userTermVersion}
                    />
                  ))}
                </tbody>
              </table>
            </div>
            {isLoading && (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(UserTermVersionList);
